module.exports = __webpack_public_path__ + "img/magento-custom-development@2x.909b1255.jpeg";